import { render, staticRenderFns } from "./UpdateEmployee.vue?vue&type=template&id=1597b70e&scoped=true"
import script from "./UpdateEmployee.vue?vue&type=script&lang=js"
export * from "./UpdateEmployee.vue?vue&type=script&lang=js"
import style0 from "./UpdateEmployee.vue?vue&type=style&index=0&id=1597b70e&lang=css"
import style1 from "./UpdateEmployee.vue?vue&type=style&index=1&id=1597b70e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1597b70e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1597b70e')) {
      api.createRecord('1597b70e', component.options)
    } else {
      api.reload('1597b70e', component.options)
    }
    module.hot.accept("./UpdateEmployee.vue?vue&type=template&id=1597b70e&scoped=true", function () {
      api.rerender('1597b70e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employee/UpdateEmployee.vue"
export default component.exports